module.exports = __webpack_public_path__ + "static/media/merriweather-bold-webfont.65d5dea5.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-bold-webfont.eot
// module id = 294
// module chunks = 0